import { ILink } from '@models/ILink';
import classNames from 'classnames';
import {
  AnchorHTMLAttributes,
  DetailedHTMLProps,
  PropsWithChildren,
} from 'react';

interface Props {
  readonly link: ILink;
  readonly type?: 'DEFAULT' | 'OUTLINE';
  readonly useSmallCard?: boolean;
  readonly dataTestId?: string;
}

type LinkCardProps = Props &
  DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

const LinkCard = ({
  type = 'DEFAULT',
  link,
  children,
  className,
  useSmallCard,
  dataTestId,
  ...linkProps
}: PropsWithChildren<LinkCardProps>) => {
  const cardClasses = classNames(
    {
      [`min-h-[110px] ${useSmallCard ? 'md:h-32' : 'md:h-36'} card h-full`]:
        type === 'DEFAULT',
    },
    {
      'rounded-[10px] border border-grey-400 transition-all hover:border-yellow':
        type === 'OUTLINE',
    },
    className,
    'mx-px flex items-center'
  );

  return (
    <a
      {...linkProps}
      href={link?.url}
      target={link?.target}
      className={cardClasses}
      data-testid={dataTestId}
    >
      {children}
    </a>
  );
};

export default LinkCard;
